import React, { useState, useEffect } from 'react';
import { Pencil, Trash2, Plus, Users, Briefcase } from 'lucide-react';
import { getAllTalent, deleteTalent } from '../../../services/talent';
import LoadingSpinner from '../../shared/LoadingSpinner';
import './TalentList.css';

const TalentList = ({ onEdit, onAdd }) => {
  const [talent, setTalent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  useEffect(() => {
    loadTalent();
  }, []);

  const loadTalent = async () => {
    setLoading(true);
    const result = await getAllTalent();
    if (result.success) {
      setTalent(result.data);
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    const result = await deleteTalent(id);
    if (result.success) {
      setTalent(talent.filter(person => person.id !== id));
      setDeleteConfirm(null);
    } else {
      alert('Error deleting talent: ' + result.error);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  if (talent.length === 0) {
    return (
      <div className="admin-empty-state">
        <div className="admin-empty-icon">
          <Users size={64} />
        </div>
        <h3 className="admin-empty-title">No Talent Yet</h3>
        <p className="admin-empty-text">
          Get started by adding your first talent to the roster.
        </p>
        <button onClick={onAdd} className="btn btn-primary">
          <Plus size={20} />
          Add First Talent
        </button>
      </div>
    );
  }

  return (
    <div className="talent-list">
      <div className="admin-cards-grid">
        {talent.map((person) => (
          <div key={person.id} className="admin-item-card">
            <div className="admin-card-image">
              {person.image ? (
                <img src={person.image} alt={person.name} />
              ) : (
                <div className="admin-card-placeholder">
                  <Users size={32} />
                </div>
              )}
              <span className={`card-status-badge ${person.available ? 'available' : 'unavailable'}`}>
                {person.available ? 'Available' : 'Booked'}
              </span>
            </div>
            <div className="admin-card-content">
              <h3 className="admin-card-title">{person.name}</h3>
              <p className="admin-card-subtitle">{person.category}</p>
              <div className="admin-card-meta">
                <span className="meta-item">
                  <Briefcase size={14} />
                  {person.experience}
                </span>
              </div>
              <div className="admin-card-footer">
                <span className="admin-card-price">${person.rate}/day</span>
                <div className="admin-card-actions">
                  <button
                    onClick={() => onEdit(person)}
                    className="btn btn-ghost btn-sm"
                    title="Edit"
                  >
                    <Pencil size={16} />
                  </button>
                  <button
                    onClick={() => setDeleteConfirm(person.id)}
                    className="btn btn-danger btn-sm"
                    title="Delete"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Delete Confirmation Modal */}
      {deleteConfirm && (
        <div className="modal-overlay" onClick={() => setDeleteConfirm(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="modal-title">Confirm Delete</h3>
            <p className="modal-text">
              Are you sure you want to delete this talent? This action cannot be undone.
            </p>
            <div className="modal-actions">
              <button
                onClick={() => setDeleteConfirm(null)}
                className="btn btn-ghost"
              >
                Cancel
              </button>
              <button
                onClick={() => handleDelete(deleteConfirm)}
                className="btn btn-danger"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TalentList;
